import { render, staticRenderFns } from "./appraisalClass.vue?vue&type=template&id=60d0a11e&"
import script from "./appraisalClass.vue?vue&type=script&lang=js&"
export * from "./appraisalClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports